import React from "react";

import fetcher from "../../../fetcher";
import QuoteHelper from "../../../utils/QuoteHelper";
import {buildTrimAndStyleDescriptionName} from "../../../utils/utils";
import {CustomerDisclosurePDF} from "../../DealPage/DisclosurePDFs/Customer/Lease/CustomerDisclosurePDF";
import {pdf} from "@react-pdf/renderer";
import {PurchaseCustomerDisclosurePDF} from "../../DealPage/DisclosurePDFs/Customer/Purchase/PurchaseCustomerDisclosurePDF";

export const getQuotesDataAndPDFs = async (quoteIds, recipient, companyName) => {
    let attachments = []
    let headerHTMLString = `<h3>Hi ${recipient},</h3>
    <p>Please review the following quotes and the attached documents: </p>
    `

    let bodyHTMLString = ""

    let footerHTMLString = "<p>Please let me know if any of these quotes interest you.</p>"

    for (let i = 0; i < quoteIds.length; i++) {
        let response = await fetcher.getDeal(quoteIds[i])
        const deal = response.data
        const car_detail = deal.car_detail
        const quoteHelper = new QuoteHelper(deal, deal.selected_quote)
        const doc = deal.is_purchase ?
            (<PurchaseCustomerDisclosurePDF
                customerName={recipient}
                deal={deal}
                companyName={companyName}
            />)
            : (<CustomerDisclosurePDF
                customerName={recipient}
                deal={deal}
                companyName={companyName}
            />)
        const pdfFile =  await pdf(doc).toBlob();
        const file = new File([pdfFile], quoteHelper.getFileName(), { type: "application/pdf" })

        attachments.push(file)

        bodyHTMLString += `
            <strong>
                ${car_detail.year} ${car_detail.make} ${car_detail.model}
                ${buildTrimAndStyleDescriptionName(car_detail.trim, car_detail.style_description)}
            </strong>
            <span>Monthly Payment: ${quoteHelper.basePayment()}</span>
            </br>
        `
    }

    const content = headerHTMLString + bodyHTMLString + footerHTMLString

    return {content, attachments}
}